import { isNotDefined } from '@hsp/utilities';

import { NlsOrderQuery } from '@t/p/nls-order/components/dashboard/nls-dashboard-parameters-model';

export const NlsDashboardQueryKeys = {
  byId: (id: string, userId?: string) => {
    if (isNotDefined(userId)) {
      return [...NlsDashboardQueryKeys.orders.all, { id }] as const;
    }

    return [...NlsDashboardQueryKeys.orders.all, { id, userId }] as const;
  },
  orders: {
    all: ['nls-orders'],
    filtered: (params: NlsOrderQuery) => [...NlsDashboardQueryKeys.orders.all, { ...params }] as const,
  },
} as const;
